import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Checkbox,
  IconButton,
  Divider,
} from "@mui/material";
import DropDown from "../../Components/Common/DropDown/DropDown";
import { useSelector, useDispatch } from "react-redux";
import { DcoiActions, downloadExcelReport, GetAllEntitiesForUserAdmin, GetSubmissionPdfDocZip, Getsumission, getUnblockRequest, RemindUser, RespondentDashboard, unblockRequest_Process, UnblockUsers } from "../../Reducers/dcoi";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CustomButton from "../../Components/Button/Button";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import "./Respondents.css";
import CountDropDown from "../../Components/Common/CountDropDown/CountDropDown";
import { Pagination } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import UserPdfDialog from "../../Components/UserPdfDialog/UserPdfDialog";
import Toster from "../../Components/Common/Toster/Toster";
import excelIcon from "../../images/icons/excel.jpg";
import Spinner from "../../Components/Common/Spinner/Spinner";


const RespondentsMUI = () => {
  const { inProgress,isUnblock,RespondentDashboardData, RespondentDashboardUsers, AllEntitiesForUserAdmin } = useSelector(
    (state) => state.dcoi
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [checkedConflict, setCheckedConflict] = useState(false);
  const [checkedAll, setCheckedAll] = useState(false);
  const [item, setItem] = useState();
  const [entity, setEntity] = useState([]);
  const [headerEntity, setHeaderEntity] = useState();
  const [report, setReport] = useState()
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRespondents, setSelectedRespondents] = useState([]);
  const [message, setMessage] = useState();
  const [severity, setSeverity] = useState();
  const [alert, setAlert] = useState(false);
  const itemsPerPage = 20;
  const [filters, setFilters] = useState({
    status: "All",
    respondentName: "",
    csid: "",
    Conflicts: "Select",
  });


  useEffect(()=>{
    dispatch(GetAllEntitiesForUserAdmin()).then((res)=>{
      if(res?.payload?.data){
        setHeaderEntity(res?.payload?.data[0]?.ID);
        dispatch(RespondentDashboard({ id: res?.payload?.data[0]?.ID }));
      }
    })
  },[])


  useEffect(() => {
    dispatch(GetAllEntitiesForUserAdmin());
    dispatch(RespondentDashboard({ id: headerEntity }));
  }, [headerEntity]);

  const handleSelectEntity = (e) => {
    setHeaderEntity(e)
    setCheckedConflict(false);
    setCheckedAll(false);
  };

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };

  const applyFilters = () => {
    const { status, respondentName, csid, Conflicts } = filters;
  
    if (
      (!status || status === "All") &&
      (!respondentName || respondentName.trim() === "") &&
      (!csid || csid.trim() === "") &&
      (!Conflicts || Conflicts === "Select")
    ) {
      setFilteredData(RespondentDashboardUsers);
      setCurrentPage(1); // Reset to first page
      return;
    }
  
    const filtered = RespondentDashboardUsers.filter((item) => {
      const userStatus = item.UserStatus?.toLowerCase();
      const matchesStatus =
        !status ||
        status === "All" ||
        (status === "Submitted" && (userStatus === "submitted" || userStatus === "unblocked")) ||
        (status === "Unsubmitted" && userStatus === "unsubmitted");
  
      const matchesName =
        !respondentName || item.Name?.toLowerCase().includes(respondentName?.toLowerCase());
      const matchesCsid =
        !csid || item?.csid?.toLowerCase().includes(csid?.toLowerCase());
  
      const matchesConflicts =
        !Conflicts || Conflicts === "Select" ||
        (Conflicts === "All" && (item.HaveConfictOfInterest || item.HavePEP)) ||
        (Conflicts === "COI" && item.HaveConfictOfInterest) ||
        (Conflicts === "PEP" && item.HavePEP);
  
      return matchesStatus && matchesName && matchesCsid && matchesConflicts;
    });
  
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page
  };
  

  const clearFilters = () => {
    setFilters({
      status: "All",
      respondentName: "",
      csid: "",
      Conflicts: "Select",
    });
    setFilteredData(RespondentDashboardUsers);
    setCurrentPage(1); // Reset to first page
  };
  


  const handleConflictChange = () => {
    setCheckedConflict(!checkedConflict);
    if (!checkedConflict) {
      setCheckedAll(false);
    }
  };

  const handleAllChange = () => {
    setCheckedAll(!checkedAll);
    if (!checkedAll) {
      setCheckedConflict(false);
    }
  };

  useEffect(() => {
    setFilteredData(RespondentDashboardUsers);
    setCurrentPage(1); // Reset page when data updates
  }, [RespondentDashboardUsers]);

  const ChangeReport = (e) => {
    setReport(e)
  }

  const ChangeEntity = (e) => {
    setEntity(Array.isArray(e) ? e : [e]); // Ensure it's an array
  }


  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // Update the "checked" condition to reflect whether all filtered data is selected
  const submittedRespondents = filteredData?.filter((item) => item?.UserStatus?.toLowerCase() === "submitted");
  const allSelected = selectedRespondents.length === submittedRespondents.length && submittedRespondents.length > 0;

  // const handleSelectAll = () => {
  //   if (allSelected) {
  //     setSelectedRespondents([]); // Unselect all
  //   } else {
  //     setSelectedRespondents(submittedRespondents.map((item) => item.ID)); // Select only "Submitted" users
  //   }
  // };


  const handleSelectAll = async() => {
    const currentPageIds = submittedRespondents.map((item) => item.ID);
    if (allSelected) {
      setSelectedRespondents((prev) =>
        prev.filter((id) => !currentPageIds.includes(id))
      );
    } else {
      setSelectedRespondents((prev) => [
        ...new Set([...prev, ...currentPageIds]),
      ]);
    }
  };





  const handleCheckboxChange = (id) => {
    setSelectedRespondents((prev) =>
      prev.includes(id) ? prev.filter((ID) => ID !== id) : [...prev, id]
    );
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedRespondents = filteredData.slice(startIndex, startIndex + itemsPerPage);
  const options1 = [{ id: 1, Label: "Total Respondents", Value: 1 }, { id: 2, Label: "Submitted", Value: 2 }, { id: 3, Label: "Unsubmitted", Value: 3 }, { id: 4, Label: "Having Conflict", Value: 4 }]
 

 
 
  const handleDownload = (item) => {
    setItem(item)
    setIsOpen(!isOpen)
  }

  const handleDownloadPopup = async (value) => {
    await dispatch(Getsumission({ PdfBlobUrl: value })).then((res) => {
      if (res?.payload?.status === 200) {
        const base64Data = res?.payload?.data?.fileContent;
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        const fileBlob = new Blob(byteArrays, { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", res?.payload?.data?.fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => {
          URL.revokeObjectURL(fileURL);
        }, 100);
        setAlert(true);
        setMessage("file downloaded Successfully")
        setSeverity("success");
        dispatch(RespondentDashboard({ id: headerEntity }));
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    }).catch((error) => {
      console.error("Error fetching PDF:", error);
    });
  }

  const handleBulkDownload = () => {
    if (selectedRespondents.length || checkedConflict || checkedAll) {
      setAlert(true);
      setMessage("File Downloading in-progress please wait...");
      setSeverity("info");
      dispatch(GetSubmissionPdfDocZip({ "EntityId": headerEntity, "id": selectedRespondents, "withConflict": checkedConflict, "withUser": checkedAll }))
        .then(async (res) => {
          if (res?.payload?.status === 200) {
            setCheckedConflict(false);
            setCheckedAll(false);
            setSelectedRespondents([]);
            const base64Data = res?.payload?.data?.fileContent;
            const byteCharacters = atob(base64Data);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
              const slice = byteCharacters.slice(offset, offset + 1024);
              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }
            const fileBlob = new Blob(byteArrays, { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(fileBlob);
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download", "file.zip");
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => {
              URL.revokeObjectURL(fileURL);
            }, 100);
            setAlert(true);
            setSeverity("success");
            setMessage("file Download Successfully")
          } else {
            setCheckedConflict(false);
            setCheckedAll(false);
            setAlert(true);
            setMessage("No Data Found...")
            setSeverity("error");
          }
        })
    } else {
      setAlert(true);
      setMessage("Please Select At Least One Value Either User CheckBox or List CheckBox");
      setSeverity("error");
    }
  }


  const handleBulkUnBlock = () => {
    if (selectedRespondents.length) {
      setAlert(true);
      setMessage("Please Wait ...");
      setSeverity("info");
        dispatch(UnblockUsers({ "id": selectedRespondents })).then((res) => {
          if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
            setAlert(true);
            setMessage(res?.payload?.data[0]?.success)
            setSeverity("success");
            setCheckedAll(false);
            setSelectedRespondents([]);
            dispatch(RespondentDashboard({ id: headerEntity }));
          } else if (res?.payload?.data[0]?.status === "error") {
            setAlert(true);
            setSeverity("error");
            setMessage(res?.payload?.data[0]?.error)
          } else {
            setAlert(true);
            setMessage("Something Went Wrong")
            setSeverity("error");
          }
        })
    } else {
      setAlert(true);
      setMessage("Please select at least one record!");
      setSeverity("error");
    }
  }

  const handleUnBlock = (data) => {
    const paylod = {
        RequestId:data?.RequestId,
        Action:"Approve",
        Comments:data?.Comments
      }
    if(isUnblock===true){
        dispatch(unblockRequest_Process(paylod)).then((res)=>{
        console.log(res?.payload?.status,res)
      if (res?.payload?.status === 200) {
        setAlert(true);
        setMessage(res?.payload?.data?.Table[0]?.Message)
        setSeverity("success");
        setCheckedAll(false);
        setSelectedRespondents([]);
        dispatch(getUnblockRequest({RequestStatus:"All"}));
      } else if (res?.error?.message) {
        setAlert(true);
        setSeverity("error");
        setMessage(res?.error?.message)
      } else {
        setCheckedAll(false);
        setSelectedRespondents([]);
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
      })
    }else{
      dispatch(UnblockUsers({ "id": [data.ID] })).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success");
        setCheckedAll(false);
        setSelectedRespondents([]);
        dispatch(RespondentDashboard({ id: headerEntity }));
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setSeverity("error");
        setMessage(res?.payload?.data[0]?.error)
      } else {
        setCheckedAll(false);
        setSelectedRespondents([]);
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    })
    }
  }

  const handleRemind = (id) => {
    dispatch(RemindUser({ "id": id })).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setAlert(true);
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success");
        setCheckedAll(false);
        setSelectedRespondents([]);
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setSeverity("error");
        setMessage(res?.payload?.data[0]?.error)
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    })
  }

  const handleDownloadExcel = () => {
    if (entity.length && report) {
      try {
        setAlert(true);
        setMessage("Please Wait Report Will Available Soon...");
        setSeverity("info");
        dispatch(downloadExcelReport({ "id": entity, "reportId": report })).then(async (res) => {
          if (res?.payload?.status === 200) {
            const base64Data = res.payload.data.fileContent;
            const byteCharacters = atob(base64Data);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
              const slice = byteCharacters.slice(offset, offset + 1024);
              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }
            const fileBlob = new Blob(byteArrays, { type: 'application/xlsx' });
            const fileURL = URL.createObjectURL(fileBlob);
            const link = document.createElement("a");
            link.href = fileURL;
            link.setAttribute("download",
              report === 4 ? "DCOI_Conflict.xlsx" :
                report === 3 ? "DCOI_Total_Un-Submitted.xlsx" :
                  report === 2 ? "DCOI_Total_Submitted.xlsx" :
                    report === 1 ? "DCOI_Total_Respondents.xlsx" :
                      ""
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => {
              URL.revokeObjectURL(fileURL);
            }, 100);
            setAlert(true);
            setMessage("Report Downloaded Successfully");
            setSeverity("success");
          }
        })
      } catch (err) {
        setAlert(true);
        setMessage("Something Went Wrong..");
        setSeverity("error");
        console.error(err)
      }
    } else {
      setAlert(true);
      setMessage("Please select item first!");
      setSeverity("error");
    }
  }
  
  const handleUnblockList = async()=>{
    await dispatch(getUnblockRequest({RequestStatus:"All"}))
  }

  return (<>
    <Box sx={{ margin: "40px" }}>
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <UserPdfDialog isVcoi={false} isOpen={isOpen} onClose={() => setIsOpen(!isOpen)} handleDownloadPopup={handleDownloadPopup} item={item} />
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={12} md={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
            <Typography variant="body1" gutterBottom>
              <b>Entity:</b>
            </Typography>
            <Box sx={{ minWidth: "300px" }}><DropDown value={headerEntity} options={AllEntitiesForUserAdmin} onChange={handleSelectEntity} /></Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={5.5} sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ padding: "20px 0px" }}>
            <b>Start Date:</b> {RespondentDashboardData?.StartTime
              ? new Date(RespondentDashboardData.StartTime).toLocaleDateString("en-US", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
              : null}
          </Typography>
          <Typography sx={{ padding: "20px 0px" }}>
            <b>End Date:</b> {RespondentDashboardData?.EndTime
              ? new Date(RespondentDashboardData.EndTime).toLocaleDateString("en-US", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
              : null}
          </Typography>
          <Typography variant="body2" sx={{
            color: " #212129", fontWeight: "bolder", display: "flex", alignItems: "center", cursor: "pointer", // Add pointer cursor
            '&:hover': {
              textDecoration: 'underline',
            }
          }} onClick={() => {
            dispatch(DcoiActions.activeDisplay({ menu: "Respondent", submenu: "Manage Cycle" }))
            navigate("/app-dcoi/sitecontent/ManageSubmissionCycle", {
              state: { CycleID: headerEntity }, // Pass data in state
            });
          }} ><EditIcon fill="#9d833e" sx={{ height: "12px" }} />Manage Cycle</Typography>
          <Box
            sx={{
              backgroundColor: " #212129",
              color: "white",
              padding: "8px",
              textAlign: "center",
            }}
          >
            <Typography>
              {RespondentDashboardData?.daysLeft}
            </Typography>
            <Typography variant="body2">DAYS LEFT</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={1.5} textAlign={{ xs: "center", sm: "right" }}>

        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{
          marginY: 2,
          borderTop: "1px solid #ccc",
          borderBottom: "1px solid #ccc",
          paddingY: 2,
          alignItems: "center",
        }}
      >
        {/* TOTAL RESPONDENTS */}
        <Grid
          item
          xs={12} sm={3} md={3}
          textAlign="center"
        >
          <Typography variant="h4">{RespondentDashboardData?.TotalCount || 0}</Typography>
          <Typography variant="body2">TOTAL RESPONDENTS</Typography>
        </Grid>

        {/* SUBMITTED */}
        <Grid item xs={12} sm={3} md={3} textAlign="center">
          <Typography variant="h4" sx={{ color: "green" }}>
            {RespondentDashboardData?.SubmittedCount || 0}
          </Typography>
          <Typography variant="body2">SUBMITTED</Typography>
        </Grid>

        {/* UNSUBMITTED */}
        <Grid item xs={12} sm={3} md={3} textAlign="center">
          <Typography variant="h4" sx={{ color: "red" }}>
            {RespondentDashboardData?.UnsubmittedCount || 0}
          </Typography>
          <Typography variant="body2">UNSUBMITTED</Typography>
        </Grid>

        <Grid
          item
          xs={12} sm={3} md={3}
          textAlign={{ xs: "left", md: "left" }}
          sx={{ borderLeft: { md: "2px solid lightGray", sm: "2px solid lightGray", xs: "none" } }}
        >
          <Divider xs={12} sx={{ display: { sm: "none", md: "none", xs: "flex", margin: "20px 0px" } }} />
          <Typography sx={{ fontWeight: "bolder" }}>Download Reports</Typography>
          &nbsp;
          &nbsp;
          <Divider sx={{ display: { sm: "flex", xs: "none" } }} />
          <Box sx={{ marginRight: "30px", marginTop: "10px" }}> 
            <CountDropDown
            isMulti={true}
            value={entity}
            options={AllEntitiesForUserAdmin}
            onChange={ChangeEntity}
            showCount={true}
          // getOptionLabel={() => `${entity.length} Selected`} 
          /></Box>
          <br />

          {/* Dropdown for Reports */}
          <Box sx={{ display: "flex", justifyContent: "flex-start",alignItems:"center" }}>
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>  <DropDown
              placeholder="SELECT REPORT"
              value={report}
              options={options1}
              onChange={ChangeReport}

            /></Box>
            <img style={{ height: "20px", width: "20px", marginLeft: "8px" }} src={excelIcon} alt="excel" />
          </Box>
          <br />
          <CustomButton label="DOWNLOAD" onClick={() => handleDownloadExcel()} />
        </Grid>
      </Grid>


      <Grid
        container
        spacing={0} // Remove default spacing
        sx={{ display: "flex", justifyContent: { xs: "left", sm: "flex-start" }, gap: "3px" }} // Add gap between buttons
      >
        <CustomButton
          label="DOWNLOAD PDF"
          sx={{ backgroundColor: "#bfa53a", flex: 1 }} // Ensure equal width
          onClick={()=>handleBulkDownload()}
        />
        <CustomButton
          label="BULK UNBLOCK"
          sx={{ backgroundColor: "#bfa53a", flex: 1 }} // Ensure equal width
          onClick={()=>handleBulkUnBlock()}
        />
        <CustomButton
          label="GET UNBLOCK REQUEST"
          sx={{ backgroundColor: "#bfa53a", flex: 1 }} // Ensure equal width
          onClick={()=>handleUnblockList()}
        />
      </Grid>


      <Grid item xs={12} sm={2} sx={{ display: "flex", justifyContent: "left" }}>
        <Grid container>
          <Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "left", marginTop: "10px" }}>
            <Checkbox sx={{ padding: "10px 0px" }} checked={checkedConflict} onChange={handleConflictChange} />
            <Typography sx={{ marginLeft: "5px" }} variant="body2">For all submitted users with Conflict</Typography>
          </Grid>

          <Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
            <Checkbox sx={{ padding: "10px 0px" }} checked={checkedAll} onChange={handleAllChange} />
            <Typography sx={{ marginLeft: "5px" }} variant="body2">For all submitted users</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container xs={12}>
        <Typography variant="h6" gutterBottom>
          Respondent Information
        </Typography>
      </Grid>
      <Box sx={{ marginTop: 3, backgroundColor: "#F6F7FA" }}>
        <Box sx={{ marginTop: 0 }}>
          <Grid
            item
            xs={12}
            onClick={toggleFilterVisibility}
            sx={{
              cursor: "pointer",
              margin: "10px 0px 0px 0px",
              fontWeight: "bolder",
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 5px",
              backgroundColor: "#E7E8E9",
              alignItems: "center",
            }}
          >
            <Box color="#9d833e" sx={{ display: "flex", alignItems: "center" }}>
              {isFilterVisible ? (
                <ArrowDropUpIcon sx={{ color: "#9d833e" }} />
              ) : (
                <ArrowDropDownIcon sx={{ color: "#9d833e" }} />
              )}
              &nbsp;&nbsp; FILTER
            </Box>
          </Grid>

          {isFilterVisible && (
            <Box sx={{ margin: 2, padding: "0px 5px" }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={3} lg={2}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>Status</Typography>
                  <select
                    className="customSelect"
                    value={filters.status}
                    onChange={(e) => handleFilterChange("status", e.target.value)}
                  >
                    <option value="All">All</option>
                    <option value="Submitted">Submitted</option>
                    <option value="Unsubmitted">Unsubmitted</option>
                  </select>
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={2}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>Respondent Name</Typography>
                  <input
                    className="customSelect"
                    value={filters.respondentName}
                    onChange={(e) => handleFilterChange("respondentName", e.target.value)}
                    placeholder="Enter Name"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={2}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>Conflicts</Typography>
                  <select
                    value={filters.Conflicts}
                    onChange={(e) => handleFilterChange("Conflicts", e.target.value)}
                    className="customSelect"
                  >
                    <option value="Select">Select</option>
                    <option value="All">All</option>
                    <option value="COI">COI</option>
                    <option value="PEP">PEP</option>
                  </select>
                </Grid>

                <Grid item xs={12} sm={6} md={3} lg={2}>
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>CS ID</Typography>
                  <input
                    className="customSelect"
                    value={filters.csid}
                    onChange={(e) => handleFilterChange("csid", e.target.value)}
                    placeholder="Enter CS ID"
                  />
                </Grid>

                <Grid item xs={6} sm={12} md={3} lg={2} mt={3} sx={{ display: "flex", justifyContent: "center" }}>
                  <CustomButton label="Show Result" color="primary" onClick={applyFilters} />
                </Grid>

                <Grid item xs={6} sm={12} md={3} lg={2} mt={3} sx={{ display: "flex", justifyContent: "center" }}>
                  <CustomButton label="Clear Filter" onClick={clearFilters} />
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Box sx={{minWidth:"1200px"}}>
        <Grid container spacing={4} sx={{ padding: 1, alignItems: "center", color: "#4D4D4D"}}>
          <Grid item xs={0.5}>
            <Checkbox
              checked={allSelected}
              onChange={()=>handleSelectAll()}
            />
          </Grid>
          <Grid item xs={1}>
            <Typography sx={{ fontWeight: 600,fontSize:"10px"}}>
              NAME
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              CSID
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              JOB TITILE
            </Typography>
          </Grid>
          <Grid item xs={1.5} sm={1.5} md={1.5}>
            <Typography sx={{ fontWeight: 600,fontSize:"10px" }}>
              SIGN-OFF DATE
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              STATUS
            </Typography>
          </Grid>
          <Grid item xs={1.5}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              HAVING COI
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              IS PEP
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              DOWNLOAD
            </Typography>
          </Grid>

          <Grid item xs={1.5} sx={{display:"flex",justifyContent:"center"}}>
            <Typography sx={{ fontWeight: 600 ,fontSize:"10px"}}>
              ACTION
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        {paginatedRespondents.length > 0 ? (
  paginatedRespondents
    ?.slice()?.sort((a, b) => a.Name.localeCompare(b.Name))?.map((item, index) => (
      <Box sx={{ width: "100%" }} key={index}>
        <Grid
          container
          spacing={4}
          sx={{
            padding: 1,
            borderBottom: "1px solid #ccc",
            alignItems: "center",
          }}
        >
          <Grid item xs={0.5} sm={0.5} md={0.5}>
            {item?.UserStatus?.toLowerCase() === "submitted" && (
              <Checkbox
                checked={selectedRespondents.includes(item.ID)}
                onChange={() => handleCheckboxChange(item.ID)}
              />
            )}
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            <Typography variant="body2">{item.Name}</Typography>
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            <Typography variant="body2">{item.csid}</Typography>
          </Grid>

          <Grid item xs={2} sm={2} md={2}>
            <Typography variant="body2">{item.JobTitle}</Typography>
          </Grid>

          <Grid item xs={1.5} sm={1.5} md={1.5}>
            <Typography>
              {item?.SignOff && !(item?.UserStatus === "Unsubmitted")
                ? new Date(item.SignOff).toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })
                : "--"}
            </Typography>
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            <Typography
              variant="body2"
              sx={{
                color:
                  item.UserStatus === "Submitted"
                    ? "green"
                    : item.UserStatus === "Unsubmitted"
                    ? "red"
                    : item.UserStatus === "Unblocked"
                    ? "#FD9A18"
                    : "",
              }}
            >
              {item.UserStatus}
            </Typography>
          </Grid>

          <Grid item xs={1.5} sm={1.5} md={1.5}>
            <Typography variant="body2">{item.HaveConfictOfInterest ? "YES" : "NO"}</Typography>
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            <Typography variant="body2">{item.HavePEP ? "YES" : "NO"}</Typography>
          </Grid>

          <Grid item xs={1} sm={1} md={1}>
            {item.UserStatus === "Submitted" || item.UserStatus === "Unblocked" ? (
              <IconButton onClick={() => handleDownload(item)}>
                <DownloadIcon sx={{ height: "25px" }} />
              </IconButton>
            ) : (
              "--"
            )}
          </Grid>

          <Grid item xs={1.5} sm={1.5} md={1.5} sx={{ display: "flex", justifyContent: "right" }}>
            {item.UserStatus === "Submitted" && (
              <CustomButton label="UnBlock" variant="contained" size="small" onClick={() => handleUnBlock(item)} />
            )}
            {item.UserStatus === "Unblocked" && (
              <CustomButton label="Cancel" variant="contained" size="small" onClick={() => handleUnBlock(item.ID)} />
            )}
            {item.UserStatus === "Unsubmitted" && (
              <CustomButton label="Remind" variant="contained" size="small" onClick={() => handleRemind(item.ID)} />
            )}
          </Grid>
        </Grid>
      </Box>
    ))
) : (
          <Typography variant="body2" sx={{ textAlign: "center", marginTop: 2, padding: "20px", color: "#4D4D4D" }}>
            No respondents Data found.
          </Typography>
        )}
        </Box>
        </Box>
        {filteredData?.length > 0 && <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Pagination showFirstButton showLastButton sx={{
            margin: "10px", fontWeight: "bolder", padding: "5px", border: "1px solid  #212129",
            borderRadius: "20px"
          }}
            count={Math.ceil(filteredData.length / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            color=" #212129"
          /></Box>}

    </Box>
    </Box>
    <Spinner isLoading={inProgress}  />
  </>);
};

export default RespondentsMUI;
